import { ArrowDropDownOutlined } from '@mui/icons-material';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import React from 'react';
import VastaanottoVarausList from '@/components/VastaanottoVaraukset/VastaanottoVarausList';
import { useTranslation } from 'react-i18next';

const VastaanottoVarausAccordion = ({ type, setSelectedVaraus }) => {
  const { t } = useTranslation();

  const TEXTS = {
    alkavat: {
      summary: t('dashboard.starting'),
      details: 'lorem ipsum dolor sit amet',
    },
    loppuvat: {
      summary: t('dashboard.ending'),
      details: 'lorem ipsum dolor sit amet',
    },
    jatkuvat: {
      summary: t('dashboard.continuing'),
      details: 'lorem ipsum dolor sit amet',
    },
  };

  const { summary, details } = TEXTS[type] || TEXTS['alkavat'];

  return (
    <React.Fragment>
      <Accordion slotProps={{ transition: { unmountOnExit: true } }}>
        <AccordionSummary
          expandIcon={<ArrowDropDownOutlined />}
          sx={{
            'minHeight': 16,
            'paddingY': 0,
            '& .MuiAccordionSummary-content': {
              margin: '8px 0',
            },
          }}
        >
          <Typography>
            {summary}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ paddingX: 2 }}>
          <VastaanottoVarausList type={type} setSelectedVaraus={setSelectedVaraus} />
        </AccordionDetails>
      </Accordion>
    </React.Fragment>
  );
};

export default VastaanottoVarausAccordion;
